module.exports = __webpack_public_path__ + "static/media/ETN_500.0f4d36c4.png";